import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { ApiUrl } from "../../../ApiUrl";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useNavigate } from "react-router-dom";

const StaffLessonPlanCompletionReport = () => {
  const navigate = useNavigate();
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);

  const resolveDocumentUrl = (rawUrl) => {
    if (!rawUrl) return "";
    if (/^https?:\/\//i.test(rawUrl)) return rawUrl;

    const baseOrigin = ApiUrl.apiurl.replace(/\/api\/?$/, "");
    const normalizedPath = rawUrl.startsWith("/") ? rawUrl : `/${rawUrl}`;
    return `${baseOrigin}${normalizedPath}`;
  };

  const fetchReportData = async () => {
    setLoading(true);
    try {
      const academicSessionId = localStorage.getItem("academicSessionId");
      const orgId = localStorage.getItem("orgId");
      const branchId = localStorage.getItem("branchId");
      const teacherId = sessionStorage.getItem("userId");

      if (!academicSessionId || !orgId || !branchId) {
        console.error("Missing session/org/branch ID.");
        setLoading(false);
        return;
      }

      let apiUrl = `${ApiUrl.apiurl}LESSION_PLAN/GetLessonPlanCompletionReport/?academic_year_id=${academicSessionId}&org_id=${orgId}&branch_id=${branchId}`;

      // Filter by teacher_id so staff only see their own records
      if (teacherId) {
        apiUrl += `&teacher_id=${teacherId}`;
      }

      const response = await fetch(apiUrl);
      const data = await response.json();

      if (response.ok && data.message === "success") {
        setReportData(data.data || []);
      } else {
        setReportData([]);
      }
    } catch (error) {
      console.error("Error fetching lesson plan report:", error);
      setReportData([]);
    } finally {
      setLoading(false);
    }
  };

  // Auto-load on mount
  useEffect(() => {
    fetchReportData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClear = () => {
    setReportData([]);
  };

  const handleExportPDF = () => {
    const doc = new jsPDF();
    doc.text("Lesson Plan Completion Report", 14, 15);

    const tableColumn = [
      "Sr. No.",
      "Teacher Name",
      "Lecture No",
      "Module No",
      "Topic Details",
      "Proposed Date",
      "Taught Date",
      "% Course Coverage",
      "Remarks"
    ];

    const tableRows = reportData.map((item, index) => [
      index + 1,
      item.teacher_name,
      item.lectureno,
      item.moduleno,
      item.topic_details,
      item.proposedDate,
      item.TaughtDate,
      item.PercentageCompleted,
      item.remarks
    ]);

    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 20,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [0, 123, 255] }
    });

    doc.save("lesson_plan_completion_report.pdf");
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body ">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                LESSON PLAN COMPLETION REPORT
              </p>

              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{ width: "150px" }}
                    onClick={handleExportPDF}
                  >
                    Export to PDF
                  </button>
                  
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{ width: "150px" }}
                    onClick={() => navigate("/staff/dashboard")}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="table-responsive">
                <table className="table table-bordered table-hover align-middle mb-0">
                  <thead className="bg-primary text-white">
                    <tr>
                      <th>Sr. No.</th>
                      <th>Teacher Name</th>
                      <th>Lecture No</th>
                      <th>Module No</th>
                      <th>Topic Details</th>
                      <th>Proposed Date</th>
                      <th>Taught Date</th>
                      <th>% Course Coverage</th>
                      <th>Remarks</th>
                      <th>Document</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan={10} className="text-center py-4">
                          Loading...
                        </td>
                      </tr>
                    ) : reportData.length === 0 ? (
                      <tr>
                        <td colSpan={10} className="text-center py-4">
                          No lesson plan records found
                        </td>
                      </tr>
                    ) : (
                      reportData.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.teacher_name || "-"}</td>
                          <td>{item.lectureno || "-"}</td>
                          <td>{item.moduleno || "-"}</td>
                          <td>{item.topic_details || "-"}</td>
                          <td>{item.proposedDate || "-"}</td>
                          <td>{item.TaughtDate || "-"}</td>
                          <td>{item.PercentageCompleted || "-"}</td>
                          <td>{item.remarks || "-"}</td>
                          <td>
                            {item.document_url ? (
                              <a
                                href={resolveDocumentUrl(item.document_url)}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-sm btn-info text-white"
                              >
                                View
                              </a>
                            ) : (
                              item.uploaded_document || "-"
                            )}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffLessonPlanCompletionReport;
